import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


import { customerTransactionModel } from '../shared/models/customerModel';
import { CustomerService } from '../shared/services/customer.service';
@Component({
  selector: 'app-customer-transaction-details',
  templateUrl: './customer-transaction-details.component.html',
  styleUrls: ['./customer-transaction-details.component.css']
})
export class CustomerTransactionDetailsComponent implements OnInit {

  @Input() payLoad : customerTransactionModel;
  InvoiceDetails : any;
  PageNo : 1;
  constructor(private CustomerService: CustomerService,public activeModal : NgbActiveModal) { }

  ngOnInit(): void {
    if(this.payLoad){
      this.getInvoiceDetails();
    }
  }

  ngOnChanges(changes : SimpleChanges){
   
  }

  getInvoiceDetails(PageNo ?: number){
    if(PageNo){
      this.payLoad.PageNo = PageNo;
    }
    this.CustomerService.getCustomerTransactionDetails(this.payLoad).subscribe((response : any) => {
      this.InvoiceDetails = response; 
    });
  }
  onClose(){
    this.activeModal.close();
  }
  }
  
  
 
